// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export const PaginationWrapper = styled.ul`
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin-top: 36px;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    margin-left: -12px;
  }
`;

export const PaginationItem = styled.li`
  height: 43px;
  text-align: center;
  margin: auto 10px;
  color: black;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  align-items: center;
  letter-spacing: 0.01071em;
  border-radius: 6px;
  line-height: 1.43;
  font-size: 24px;
  min-width: 42px;
  font-weight: 500;
  border: 1px solid black;

  &:hover {
    background-color: black;
    color: white;
    cursor: pointer;
  }

  &.selected {
    background-color: black;
    color: white;
  }

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    font-size: 18px;
    height: 38px;
    min-width: 38px;
    margin: auto 6px;
  }
`;

export const MoveIcon = styled.li`
  cursor: pointer;
`;

export const ArrowBlock = styled.div`
  margin: 0 20px;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    margin: 0 10px;
  }
  &::before {
    position: relative;
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-right: 0.12em solid rgba(0, 0, 0, 0.87);
    border-top: 0.12em solid rgba(0, 0, 0, 0.87);
  }

  &.left {
    padding-right: 10px;
    transform: rotate(-135deg) translate(-50%);
  }

  &.right {
    padding-top: 14px;
    transform: rotate(45deg);
  }
`;

export const Dots = styled.li`
  position: relative;
  top: 22px;
  margin: 0 10px;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    margin: 0 6px;
  }
  &:hover {
    background-color: transparent;
    cursor: default;
  }
`;

export default css`
  .disabled {
    pointer-events: none;
    opacity: 0.2;

    &:hover {
      background-color: transparent;
      cursor: not-allowed;
    }
  }
`;
